import { render, staticRenderFns } from "./WechatMsg.vue?vue&type=template&id=60ea4f06&scoped=true&"
import script from "./WechatMsg.vue?vue&type=script&lang=js&"
export * from "./WechatMsg.vue?vue&type=script&lang=js&"
import style0 from "./WechatMsg.vue?vue&type=style&index=0&id=60ea4f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea4f06",
  null
  
)

export default component.exports